import { Box, Typography, Avatar } from '@mui/material';

type PlacementStat = {
  placementGroup: string;
  revenue: number;
};

type Props = {
  top5PlacementStats: PlacementStat[];
  bottom5PlacementStats: PlacementStat[];
};

const krw = (n: number) =>
  new Intl.NumberFormat('ko-KR', { style: 'currency', currency: 'KRW', maximumFractionDigits: 0 }).format(n);

function Pill({ item }: { item: PlacementStat }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 1, sm: 1.25 },
        p: { xs: 1, sm: 1.25 },
        borderRadius: 9999,
        border: '1px solid #E0E3E7',
        bgcolor: '#fff',
        minWidth: 0,
        overflow: 'hidden',
      }}
    >
      <Avatar
        sx={{
          width: { xs: 28, sm: 36, md: 40 },
          height: { xs: 28, sm: 36, md: 40 },
          bgcolor: '#EEF2F6',
          color: '#455A64',
          fontWeight: 700,
          fontSize: { xs: 12, sm: 14 },
          flexShrink: 0,
        }}
      >
        {item.placementGroup?.[0] ?? '?'}
      </Avatar>

      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography variant="subtitle2" noWrap title={item.placementGroup}>
          {item.placementGroup}
        </Typography>
        <Typography variant="subtitle2" fontWeight={700}>
          {krw(item.revenue)}
        </Typography>
      </Box>
    </Box>
  );
}

const GRID5 = {
  display: 'grid',
  gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
  gap: { xs: 1, sm: 1.5 },
} as const;

function Section({
  title,
  items,
  emptyText,
}: {
  title: string;
  items: PlacementStat[];
  emptyText: string;
}) {
  return (
    <Box sx={{ mt: 1, overflowX: 'hidden' }}>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Box sx={GRID5}>
        {items.length === 0 ? (
          <Box
            sx={{
              gridColumn: '1 / -1',
              p: 1.25,
              borderRadius: 1,
              border: '1px dashed #E0E3E7',
              bgcolor: '#FAFAFA',
            }}
            aria-live="polite"
          >
            <Typography variant="body2" color="text.secondary">
              {emptyText}
            </Typography>
          </Box>
        ) : (
          <>
            {items.slice(0, 5).map((it, index) => (
              <Pill key={`top-${it.placementGroup}-${index}`} item={it} />
            ))}
            {Array.from({ length: Math.max(0, 5 - items.length) }).map((_, i) => (
              <Box key={`empty-${i}`} />
            ))}
          </>
        )}
      </Box>
    </Box>
  );
}

export default function AdpopcornPlacementDeltaTop5({ top5PlacementStats, bottom5PlacementStats }: Props) {
  return (
    <Box sx={{ mt: 2, overflowX: 'hidden' }}>
      <Section title="매출 TOP 지면" items={top5PlacementStats} emptyText="데이터가 없습니다." />
      <Section title="매출 LOW 지면" items={bottom5PlacementStats} emptyText="데이터가 없습니다." />
    </Box>
  );
}
